import {
  type WorkerRequirementIncludedAutomatedNameUpdateType,
  type WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { useState } from "react";

import { type OnboardingPageHeaderProps } from "../SharedPageHeader";
import { OnboardingPersonalIdInReview } from "./InReview";
import {
  type OnboardingPersonalIdVerificationAnalytics,
  type OnboardingPersonalIdVerificationStep,
} from "./types";
import { getStepFromRequirementStatus } from "./utils";
import { OnboardingPersonalIdVerification } from "./Verification";

interface OnboardingPersonalIdVerificationPageProps
  extends Pick<OnboardingPageHeaderProps, "progress"> {
  requirementId: string;
  requirementStatus: WorkerRequirementStatus;
  onBack: () => void;
  onNext: () => void;
  analytics: OnboardingPersonalIdVerificationAnalytics;
  automatedNameUpdate?: WorkerRequirementIncludedAutomatedNameUpdateType;
}

export function OnboardingPersonalIdVerificationPage({
  requirementId,
  requirementStatus,
  analytics,
  onBack,
  onNext,
  progress,
  automatedNameUpdate,
}: OnboardingPersonalIdVerificationPageProps) {
  const [currentStep, setCurrentStep] = useState<OnboardingPersonalIdVerificationStep>(
    getStepFromRequirementStatus(requirementStatus)
  );

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (currentStep) {
    case "start-verification":
    case "approved":
    case "in-progress": {
      return (
        <OnboardingPersonalIdVerification
          requirementId={requirementId}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          analytics={analytics}
          progress={progress}
          automatedNameUpdate={automatedNameUpdate}
          onBack={onBack}
          onNext={onNext}
        />
      );
    }

    default: {
      return (
        <OnboardingPersonalIdInReview
          isLoading={false}
          analytics={{ ...analytics, requirementStatus }}
          progress={progress}
          onBack={onBack}
          onNext={onNext}
        />
      );
    }
  }
}
